// @flow

import { type Country } from '@tectonics/prs/country';
import { type PaymentMethodCode } from '@tectonics/prs/payment-method';
import { type PrsSupport } from './types';

export function getSafeCountryIntegrations(country: Country, support: PrsSupport): ImmutableArray<PaymentMethodCode> {
  const integration = support.integrations[country];
  if (!integration) {
    throw new Error(`Support - No integrations found for country ${country}`);
  }
  return integration;
}
